/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./giftInventory.vue?vue&type=template&id=58449e0f"
import script from "./giftInventory.vue?vue&type=script&lang=js"
export * from "./giftInventory.vue?vue&type=script&lang=js"
import style0 from "./giftInventory.vue?vue&type=style&index=0&id=58449e0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports